import { render, staticRenderFns } from "./HomeCompliance.vue?vue&type=template&id=b38d2b58&scoped=true"
import script from "./HomeCompliance.vue?vue&type=script&lang=js"
export * from "./HomeCompliance.vue?vue&type=script&lang=js"
import style0 from "./HomeCompliance.vue?vue&type=style&index=0&id=b38d2b58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38d2b58",
  null
  
)

export default component.exports